import React from "react";
import { Row, Col } from "react-bootstrap";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import TitleSection from "../TitleSection/TitleSection";
import MenuCategory from "./MenuCategory";
import eatAndPlayConfig from "../../config/eatAndPlayConfig";

const TabContent = ({ categoryKey, t }) => {
  // const { t } = useTranslation();
  const categoryHeading = t(`eatAndPlay.${categoryKey}.heading`);
  const categoryDescription = t(`eatAndPlay.${categoryKey}.description`);

  // Get the appropriate config section based on the category
  const configSection = categoryKey.includes("Breakfast") ? "breakfast" : "main";

  return (
    <container-fluid>
      <TitleSection
        as={'h2'}
        title={t(categoryHeading)}
        text={t(categoryDescription)}
        className="pt-2"
      />
      <Row className="gx-4 gy-4">
        {/* Render menu categories based on the config */}
        {Object.keys(eatAndPlayConfig[configSection]).map((sectionKey, index) => (
          <Col key={index} lg={4} md={6} sm={12}>
            <MenuCategory
              menuSection={sectionKey}
              menuType={categoryKey}
              t={t}
              config={{
                ...eatAndPlayConfig[configSection],
                extras: eatAndPlayConfig.extras
              }}
            />
          </Col>
        ))}
      </Row>
    </container-fluid>
  );
};

export default TabContent;
